import { SelectTable } from "_components/Abstractions/SelectTable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ExternalWeighingContractorTable } from "./ExternalWeighingContractorTable";
import { ordersActions } from "../../../../_store/order.slice";
import { DomainButton } from "../../../../_components/Abstractions/DomainButton";

export function ExternalWeighingContractorSelect({ onSelect, overrideLabel, multiple = false, defaultValues }) {
  const [show, setShow] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState(defaultValues ?? []);
  const dispatch = useDispatch();

  const onSearchChange = async (searchQuery) => {
    setItems({ loading: true });
    const { payload } = await dispatch(ordersActions.searchExternalWeighingContractors({ searchQuery }));
    setItems(payload);
  };

  const onSelectItem = (item) => {
    onSelect(item);
    setShow(false);
  };

  useEffect(() => {
    console.log({ selectedItems });
  }, [selectedItems]);

  const selectedContent = <div className="d-flex justify-content-end mb-2">
    <DomainButton onClick={() => onSelectItem(selectedItems)}>Przypisz programy wagowe</DomainButton>
  </div>

  const table = <ExternalWeighingContractorTable
    items={items}
    onSelect={onSelectItem}
    multiSelect={multiple}
    onSelectedItemsChanged={setSelectedItems}
    selectedItems={selectedItems}
  />;

  return (
    <>
      <SelectTable
        table={table}
        label={overrideLabel ?? "Powiąż z programem wagowym"}
        onSearchChange={onSearchChange}
        show={show}
        selectContent={multiple && selectedContent}
        setShow={setShow}
      />
    </>
  );
}
